import React, { useCallback, useReducer } from 'react'
import { actionTypes, initialState, reducer } from './reducer'
import { Form, FormGroup, Label, ModalBody } from 'reactstrap'
import { ValidationBoundary, Validator, ValidationState } from '@/components/validation'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { ConfirmFooter } from '@/dialogs/common/confirmFooter'
import { Input } from '@/components/inputs'
import { CheckBox } from '@/components/CheckBox'
import Resx from '@/components/Resx'

function UserRowDialog (props) {
  const { value, latinValue, existingCodes, onAction } = props
  const [ state, dispatch ] = useReducer(reducer, initialState(value, latinValue))

  const onSave = useCallback(() => { onAction({ value: state.value, latinValue: state.latinValue }) }, [onAction, state.value, state.latinValue])
  const onValueChange = useCallback((event) => { dispatch({ type: actionTypes.setValue, data: event.target.value }) }, [])
  const onLatinValueChange = useCallback((event) => { dispatch({ type: actionTypes.setLatinValue, data: event.target.value }) }, [])
  const onSameValuesChange = useCallback((checked) => { dispatch({ type: actionTypes.setSameValue, data: checked }) }, [])
  const onValidate = useCallback(({ value }) => {
    if (existingCodes.includes(`[${value}]`)) return 'Reporting.CantSaveDuplicateRow'
  }, [existingCodes])

  return (
    <ValidationBoundary>
      <BasicHeader title='Reporting.UserRowDialog' {...props} />
      <ModalBody>
        <Form>
          <FormGroup>
            <Label><Resx name='Common.Value' /></Label>
            <Validator name='value' value={state.value} required onValidate={onValidate}>
              <Input
                autoFocus
                defaultValue={state.value}
                onChange={onValueChange} />
            </Validator>
          </FormGroup>
          {!state.sameValues
            ? <FormGroup>
              <Label><Resx name='Common.LatinValue' /></Label>
              <Validator name='latinValue' value={state.latinValue} required>
                <Input
                  defaultValue={state.latinValue}
                  onChange={onLatinValueChange} />
              </Validator>
            </FormGroup> : <React.Fragment /> }
          <CheckBox checked={state.sameValues}
            onChange={onSameValuesChange}
            title='Reporting.AreValuesSame' />
        </Form>
      </ModalBody>
      <ValidationState render={({ isValid }) =>
        <ConfirmFooter
          primaryButtonText='Common.SaveAndClose'
          icon='save' {...props}
          disabled={!isValid}
          onAction={onSave} />}
      />
    </ValidationBoundary>
  )
}

export default {
  component: UserRowDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/userRow/userRow.js